import { renderTagList } from './tagUtils';

const tagList = value => renderTagList(value);

export default tagList;
